var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 25 25",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.4429 14.7246h7.5332c1.8462 0 2.7925-.9277 2.7925-2.7554v-5.21383c0-1.82764-.9463-2.75537-2.7925-2.75537h-7.5332c-1.8555 0-2.7832.92773-2.7832 2.75537v5.21383c0 1.8277.9277 2.7554 2.7832 2.7554zm-13.4429-4.74071h9.4258v-2.80176c0-.23193.0093-.46387.0093-.67725-.2413 0-.4175 0-.65873 0-.58448-.00927-.92774-.14843-1.35449-.51025l-.51026-.42676c-.59375-.4917-1.04834-.64941-1.92969-.64941h-2.4956c-1.56787 0-2.48633.8999-2.48633 2.69043zm17.2095 2.19871c-.334 0-.5567-.2226-.5567-.5566v-1.70705h-1.6977c-.334 0-.5567-.21338-.5567-.55665 0-.33398.2227-.55664.5567-.55664h1.6977v-1.69775c0-.32471.2227-.55664.5567-.55664.3432 0 .5659.22266.5659.55664v1.69775h1.6977c.3248 0 .5567.22266.5567.55664 0 .34327-.2319.55665-.5567.55665h-1.6977v1.70705c0 .334-.2227.5566-.5659.5566zm-14.40774 8.8877h14.63964c1.6143 0 2.5513-1.0947 2.5513-2.9224v-2.1987h-6.5498c-2.5235 0-4.0171-1.4658-4.0171-3.9707v-.8071h-9.4258v7.1343c0 1.8369.94629 2.7646 2.80176 2.7646z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.b118aa4a.svg";
export { ForwardRef as ReactComponent };